<template>
  <!-- modelConfiguration   模型配置-->
  <el-card class="tabs-card">
    <el-tabs class="tabs-box" v-model="activeName" tab-position="top">
      <el-tab-pane label="列表模式" name="one">
        <alarmTable
          ref="tableListRef"
          :tableParams="tableParams"
          :alarmTablestatus="alarmTablestatus"
        ></alarmTable>
      </el-tab-pane>
      <el-tab-pane label="地图模式" name="two">
        <alarmMap
          v-if="activeName == 'two'"
          :tableParams="tableParams"
        ></alarmMap>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import alarmTable from "./components/alarmTable.vue";
import alarmMap from "./components/alarmMap.vue";
import moment from "moment";
export default defineComponent({
  name: "realtimeAlarm",
  components: { alarmTable, alarmMap },
  props: {},
  setup(props) {
    const data = reactive({
      activeName: "one",
      alarmTablestatus: "0", // 0:实时告警  1：通用告警
      tableParams: {
        search: "",
        alarmStatus: "", // 告警状态
        alarmType: "", // 告警类型
        alarmSource: "", // 告警源类型
        startTime: moment(new Date().getTime() - 1000 * 60).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        type: "2", // 告警页面类型 1:通用,2:人脸 3:车辆
        deviceId: [],
      },
    });
    const refData = toRefs(data);
    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped></style>
